import { useState, useEffect } from "react";
import styled from "styled-components";
import "react-nice-dates/build/style.css";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  Card,
  CardBody,
  CardFooter,
  Button,
} from "reactstrap/lib";
import Rating from "@mui/material/Rating";
import ScrollContainer from "react-indiana-drag-scroll";
import { FormattedMessage } from "react-intl";
import APLRatingModal from "../Modal/APLRatingModal";
import { Tab, Tabs, Box } from "@mui/material";
import { PacmanLoader } from "react-spinners";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export default function APLRatings({
  ratingLevel,
  setRatingLevel,
  studentRatings,
  supervisorRatings,
  handleSaveEvaluationQuestions,
  activePeriodId,
  studentQuestions,
  setStudentQuestions,
  supervisorQuestions,
  setSupervisorQuestions,
  questionsToDelete,
  setQuestionsToDelete,
  loading,
  level,
  students,
  objId,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [unansweredSupervisor, setUnansweredSupervisor] = useState([]);
  const [unansweredStudent, setUnansweredStudent] = useState([]);
  const [newStudentQuestions, setNewStudentQuestions] = useState([]);
  const [newSupervisorQuestions, setNewSupervisorQuestions] = useState([]);
  const [studentRatingsForLevel, setStudentRatingsForLevel] = useState([]);
  const [supervisorRatingsForLevel, setSupervisorRatingsForLevel] = useState(
    []
  );

  useEffect(() => {
    let studentRatingsUnansweredQuestions = [];
    let unansweredStudentQuestions = studentQuestions.filter(function (
      array_el
    ) {
      return (
        studentRatings.filter(function (anotherOne_el) {
          return anotherOne_el.questionId === array_el.id;
        }).length === 0
      );
    });
    unansweredStudentQuestions.forEach((r) => {
      let emptyQuestion = {
        respons: 0,
        id: "unanseredStudentQuestion" + r.id,
        question: { question: r.question, responseRange: r.responseRange },
      };
      studentRatingsUnansweredQuestions.push(emptyQuestion);
    });
    setUnansweredStudent(studentRatingsUnansweredQuestions);
    setNewStudentQuestions([...studentQuestions]);
    let tempStudentRatingsForLevel = studentRatings.filter((rating) =>
      students.some((user) => user.email === rating.user.email)
    );
    if (level === "Class" || level === "Program") {
      let separatedRatings = _.groupBy(
        tempStudentRatingsForLevel,
        "questionId"
      );
      let tempAverageAnswer;
      let tempStudentQuestionsAverages = { ...separatedRatings };
      let tempAverageTotal = [];
      Object.entries(tempStudentQuestionsAverages).forEach((entry) => {
        const [key, value] = entry;
        let tempAnswer = 0;
        value.forEach((answer) => {
          tempAverageAnswer = Object.assign({}, answer);
          tempAnswer += answer.respons;
        });
        tempAverageAnswer.respons = tempAnswer / value.length;
        tempAverageAnswer.user = null;
        tempAverageAnswer.userId = null;
        tempAverageAnswer.questionId = key;
        tempAverageTotal.push(tempAverageAnswer);
      });
      setStudentRatingsForLevel(tempAverageTotal);
    } else {
      setStudentRatingsForLevel(tempStudentRatingsForLevel);
    }
  }, [studentQuestions, studentRatings, level, students, objId]);

  useEffect(() => {
    let supervisorRatingsUnansweredQuestions = [];
    let tempUnanswered = [];
    supervisorQuestions.forEach((q) => {
      if (
        !supervisorRatings.some(
          (rating) =>
            rating.questionId === q.id &&
            students.some((user) => user.email === rating.user.email)
        )
      ) {
        tempUnanswered.push(q);
      }
    });
    tempUnanswered.forEach((r) => {
      let emptyQuestion = {
        respons: 0,
        id: "unanseredSupervisorQuestion" + r.id,
        question: {
          question: r.question,
          responseRange: r.responseRange,
          sortOrder: r.sortOrder,
        },
      };
      supervisorRatingsUnansweredQuestions.push(emptyQuestion);
    });
    tempUnanswered = tempUnanswered.sort((a, b) => a.sortOrder - b.sortOrder);

    setUnansweredSupervisor(supervisorRatingsUnansweredQuestions);
    setNewSupervisorQuestions([...supervisorQuestions]);

    let tempSupervisorRatingsForLevel = supervisorRatings.filter((rating) =>
      students.some((user) => user.email === rating.user.email)
    );
    if (level === "Class" || level === "Program") {
      let separatedRatings = _.groupBy(
        tempSupervisorRatingsForLevel,
        "questionId"
      );
      let tempAverageAnswer;
      let tempSupervisorQuestionsAverages = { ...separatedRatings };
      let tempAverageTotal = [];
      Object.entries(tempSupervisorQuestionsAverages).forEach((entry) => {
        const [key, value] = entry;
        let tempAnswer = 0;
        value.forEach((answer) => {
          tempAverageAnswer = Object.assign({}, answer);
          tempAnswer += answer.respons;
        });
        tempAverageAnswer.respons = tempAnswer / value.length;
        tempAverageAnswer.user = null;
        tempAverageAnswer.userId = null;
        tempAverageAnswer.questionId = key;
        tempAverageTotal.push(tempAverageAnswer);
      });
      setSupervisorRatingsForLevel(tempAverageTotal);
    } else {
      setSupervisorRatingsForLevel(tempSupervisorRatingsForLevel);
    }
  }, [supervisorQuestions, supervisorRatings, level, students, objId]);

  const toggle = () => setIsOpen(!isOpen);
  const selectRating = (ratingLevel) => {
    switch (ratingLevel) {
      case "student":
        return (
          <div>
            {level === "Program" && (
              <Row className="ms-2">
                <Col>
                  <span className="small">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      color="#20a8d8"
                      className="me-1"
                    />
                    <FormattedMessage id="AverageOfAssessmentIsShownHereForProgram" />
                  </span>
                </Col>
              </Row>
            )}
            {level === "Class" && (
              <Row className="ms-2">
                <Col>
                  <span className="small">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      color="#20a8d8"
                      className="me-1"
                    />
                    <FormattedMessage id="AverageOfAssessmentIsShownHereForClass" />
                  </span>
                </Col>
              </Row>
            )}
            {studentRatingsForLevel.map((studRatings, index) => {
              return (
                <Row
                  key={studRatings.id}
                  style={{ margin: "auto", paddingTop: "1rem" }}
                >
                  <Col>
                    <Label style={{ margin: "0" }}>
                      {studRatings.question.question}
                    </Label>
                    <br />
                    <Rating
                      value={studRatings.respons}
                      max={studRatings.question.responseRange}
                      readOnly
                    />
                  </Col>
                </Row>
              );
            })}
            {unansweredStudent.map((t, index) => {
              return (
                <Row key={t.id} style={{ margin: "auto", paddingTop: "1rem" }}>
                  <Col>
                    <Label style={{ margin: "0" }}>{t.question.question}</Label>
                    <br />
                    <Rating
                      value={t.respons}
                      max={t.question.responseRange}
                      readOnly
                    />
                  </Col>
                </Row>
              );
            })}
          </div>
        );
      case "supervisor":
        return (
          <div>
            {level === "Program" && (
              <Row className="ms-2">
                <Col>
                  <span className="small">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      color="#20a8d8"
                      className="me-1"
                    />
                    <FormattedMessage id="AverageOfAssessmentIsShownHereForProgram" />
                  </span>
                </Col>
              </Row>
            )}
            {level === "Class" && (
              <Row className="ms-2">
                <Col>
                  <span className="small">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      color="#20a8d8"
                      className="me-1"
                    />
                    <FormattedMessage id="AverageOfAssessmentIsShownHereForClass" />
                  </span>
                </Col>
              </Row>
            )}
            {supervisorRatingsForLevel.map((supRatings, index) => {
              return (
                <Row
                  key={supRatings.id}
                  style={{ margin: "auto", paddingTop: "1rem" }}
                >
                  <Col>
                    <Label style={{ margin: "0" }}>
                      {supRatings.question.question}
                    </Label>
                    <br />
                    <Rating
                      value={supRatings.respons}
                      max={supRatings.question.responseRange}
                      readOnly
                    />
                  </Col>
                </Row>
              );
            })}
            {unansweredSupervisor.map((t, index) => {
              return (
                <Row key={t.id} style={{ margin: "auto", paddingTop: "1rem" }}>
                  <Col>
                    <Label style={{ margin: "0" }}>{t.question.question}</Label>
                    <br />
                    <Rating
                      value={t.respons}
                      max={t.question.responseRange}
                      readOnly
                    />
                  </Col>
                </Row>
              );
            })}
          </div>
        );
      default:
        return;
    }
  };

  const handleChange = (event, newValue) => {
    setRatingLevel(newValue);
  };

  return (
    <Col lg={12}>
      <Card style={{ height: "35vh", marginBottom: "1rem" }}>
        <ScrollContainer style={{ minHeight: "3rem" }} vertical={false}>
          <Box sx={{ bgcolor: "background.paper" }}>
            <Tabs
              value={ratingLevel}
              onChange={handleChange}
              indicatorColor="white"
            >
              <Tab
                className={
                  ratingLevel === "student"
                    ? "apl-administer-tabs--Selected"
                    : "apl-administer-tabs--UnSelected"
                }
                label={<FormattedMessage id="EvaluationQuestionsStudent" />}
                value="student"
                wrapped
              />
              <Tab
                className={
                  ratingLevel === "supervisor"
                    ? "apl-administer-tabs--Selected"
                    : "apl-administer-tabs--UnSelected"
                }
                label={<FormattedMessage id="EvaluationQuestionsSupervisor" />}
                value="supervisor"
                wrapped
              />
            </Tabs>
          </Box>
        </ScrollContainer>
        {loading ? (
          <div
            className="sweet-loading"
            style={{ position: "relative", top: "20%", left: "50%" }}
          >
            <PacmanLoader color={"#20a8d8"} loading={true} />
          </div>
        ) : (
          <Row style={{ margin: "0", overflowY: "auto" }}>
            {selectRating(ratingLevel)}
          </Row>
        )}
        <Modal isOpen={isOpen} toggle={toggle}>
          <ModalHeader>
            {" "}
            <FormattedMessage id="Ratings" />
          </ModalHeader>
          <Card style={{ marginBottom: "0", height: "34rem" }}>
            <CardBody style={{ overflowY: "auto" }}>
              <CardTitle>
                {" "}
                <p className="lead">
                  <FormattedMessage id="Ratings" />
                </p>
              </CardTitle>
              <ModalBody style={{ border: "none", padding: "0" }}>
                <APLRatingModal
                  studentQuestions={studentQuestions}
                  setStudentQuestions={setStudentQuestions}
                  supervisorQuestions={supervisorQuestions}
                  setSupervisorQuestions={setSupervisorQuestions}
                  questionsToDelete={questionsToDelete}
                  setQuestionsToDelete={setQuestionsToDelete}
                  setNewStudentQuestions={setNewStudentQuestions}
                  setNewSupervisorQuestions={setNewSupervisorQuestions}
                  newStudentQuestions={newStudentQuestions}
                  newSupervisorQuestions={newSupervisorQuestions}
                />
              </ModalBody>
            </CardBody>
            <CardFooter>
              <div className="justify-content-end d-flex">
                <Button
                  outline
                  className="m-2"
                  color="secondary"
                  onClick={toggle}
                >
                  <FormattedMessage id="Cancel" />
                </Button>
                <Button
                  color="primary"
                  outline
                  className="m-2"
                  onClick={() => {
                    handleSaveEvaluationQuestions(
                      activePeriodId,
                      newStudentQuestions,
                      newSupervisorQuestions
                    );
                  }}
                >
                  <FormattedMessage id="Save" />
                </Button>
                <Button
                  color="primary"
                  outline
                  className="m-2"
                  onClick={() => {
                    handleSaveEvaluationQuestions(
                      activePeriodId,
                      newStudentQuestions,
                      newSupervisorQuestions
                    );
                    toggle();
                  }}
                >
                  <FormattedMessage id="SaveAndClose" />
                </Button>
              </div>
            </CardFooter>
          </Card>
        </Modal>
        <CardFooter className="mt-auto py-0">
          <div className="justify-content-end d-flex">
            <Button outline color="primary" className="m-2" onClick={toggle}>
              <FormattedMessage id="EditQuestions" />
            </Button>
          </div>
        </CardFooter>
      </Card>
    </Col>
  );
}

const Label = styled.label`
  margin: auto 1rem;
  background: white;
`;
